import React from 'react'
import { Field, FieldArray } from 'redux-form'
import { RenderField, RenderFields } from './index'
import { Img, LightButton } from 'styles/GlobalStyle'
import { Add } from '@mui/icons-material'
import { ReadOnlyFieldStyles } from './Styled'

const RenderArray = (props) => {
    const { fields, buildFields, className } = props
    return (
        fields.map((field, arrayIndex) =>
            <div className={className}>
                <RenderFields
                    arrayFields={fields}
                    fields={buildFields}
                    name={`${field}`}
                    key={field}
                    arrayIndex={arrayIndex}
                    index={arrayIndex}
                />
                {field.addNewItem &&
                    <LightButton variant="solid" action={() => fields.push()} size="small">
                        <Add />
                    </LightButton>
                }
            </div>
        )
    )
}

const RenderMultipeFields = (props) => {
    const { buildFields, name, className } = props

    return (
        <FieldArray name={name} props={{ buildFields: buildFields, name: name, className: className }} component={RenderArray} />
    )
}

// Render fields
const Fields = (props) => {
    const { fields, name, arrayIndex, arrayFields, readOnly } = props

    const getDisplayValue = (value, field) => {
        if (!value) return ''
        if (field.component == 'uploadFile')
            return !value || <div className='img'>
                <Img src={value} />
            </div>
        if (typeof value === 'object') return value.label || value.name || ''
        return value
    }

    return (
        fields.map((field) =>
            field.fields ?
                <RenderMultipeFields
                    // name={`${field.name}`}
                    className={field.className}
                    buildFields={field.fields}
                    key={name ? `${name}.${field.name}` : field.name}
                    name={
                        name ? `${name}${field.name ? `.${field.name}` : ''}` : field.name
                    }
                />
                :
                (readOnly ?
                    <Field
                        key={name ? `${name}.${field.name}` : field.name}
                        name={name ? `${name}.${field.name}` : field.name}
                        subscription={{ value: true }}
                        component={({ input }) => (
                            field.hide ||
                            <ReadOnlyFieldStyles>
                                <div className='label'>
                                    {field.placeholder || field.label}
                                    {field.required && "*"}
                                    :
                                </div>
                                <div className='value'>{getDisplayValue(input.value, field) || "-"} </div>
                            </ReadOnlyFieldStyles>
                        )}
                    />
                    :
                    <Field
                        {...field}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter')
                                e.preventDefault()

                            field?.onKeyDown()
                        }}
                        dynamicComponent={field.component}
                        key={name ? `${name}.${field.name}` : field.name}
                        type={field.type || 'text'}
                        component={RenderField}
                        // name={name ? `${name}${field.name ? `.${field.name}` : ""}` : field.name}
                        name={name ? `${name}.${field.name}` : field.name}
                        arrayIndex={arrayIndex + 1}
                        index={arrayIndex}
                    />
                ))
    )
}

export default Fields;